<template>
  <v-container class="limited">
    <beneficiary-data></beneficiary-data>
    <v-data-table
      :headers="headers"
      :items="documentos.content"
      :pagination.sync="pagination"
      :total-items="documentos.totalElements"
      :loading="isLoading"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      class="elevation-5"
      :rows-per-page-items="pageOptions"
    >
      <template v-slot:items="props">
        <td>{{ props.item.titulo }}</td>
        <td>{{ props.item.descricao }}</td>
        <td>{{ props.item.dataCriacao | formatDate }}</td>
        <td>
          <v-btn
            flat
            small
            color="primary"
            @click="download(props.item.anexo)"
            v-if="props.item.anexo"
            >Baixar</v-btn
          >
        </td>
      </template>
      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import BeneficiaryData from "@/components/BeneficiaryData";
import { getAnexo, getDocumentos } from "@/services/beneficiario";
import { download } from "@/utils/download";

const { mapState } = createNamespacedHelpers("beneficiario");
const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "Document",
  components: {
    BeneficiaryData
  },
  computed: {
    ...mapState(["dadosBeneficiario"]),
    contratoId() {
      return this.dadosBeneficiario.contratoId;
    },
    planoRegistroAns() {
      return this.dadosBeneficiario.planoRegistroAns;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.carregaDocumentos();
      }
    },
    planoRegistroAns: {
      handler() {
        this.carregaDocumentos();
      }
    }
  },
  data() {
    return {
      totalElements: null,
      pageOptions: [5, 10, 25, { value: -1, text: "Todos" }],
      dialog: false,
      isLoading: false,
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      headers: [
        { text: "Titulo", value: "titulo", sortable: false },
        { text: "Descrição", value: "descricao", sortable: false },
        { text: "Data Criação", value: "dataCriacao", sortable: false },
        { text: "Anexo", value: "anexo", sortable: false }
      ],
      documentos: {
        content: []
      }
    };
  },
  async created() {
    await this.carregaDocumentos();
  },
  methods: {
    ...mapMutations(["setErrorToast"]),
    download(anexo) {
      getAnexo(anexo.identificador)
        .then(async response => {
          if (response) {
            const fileBase64 = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(response);
              reader.onload = () => resolve(reader.result.split(",")[1]);
              reader.onerror = error => reject(error);
            });

            download(fileBase64, anexo.filename);
          }
        })
        .catch(() => this.$toast.error("Ocorreu um erro ao baixar o arquivo."));
    },
    getSize() {
      return this.pagination.rowsPerPage == -1
        ? this.totalElements
        : this.pagination.rowsPerPage;
    },
    carregaDocumentos() {
      this.isLoading = true;

      const payload = {
        contratoId: this.contratoId,
        codigoPlano: this.planoRegistroAns.trim(),
        page: this.pagination.page - 1,
        size: this.getSize()
      };

      return getDocumentos(payload)
        .then(({ data, errors }) => {
          this.documentos = data;
          this.totalElements = data.totalElements;
          if (errors && errors.length) {
            const errorMessage = errors[0].message.split(": ")[1];

            this.setErrorToast(errorMessage);
          }
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style></style>
